<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / Cadastro/Equipamento/Implementos </label>
      <router-link to="/acessorio"></router-link>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-row align="center">
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="implementos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Implemento *"
              v-model="nome"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Implemento é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Descrição"
              v-model="descricao"
              v-uppercase
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="3">
            <v-menu
              v-model="data1"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDate1"
                  clearable
                  label="Data aquisição"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="dataAquisicao = null"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataAquisicao"
                @change="data1 = false"
                :max="nowDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <vuetify-money
              v-model="valorAquisicao"
              label="Valor aquisicao"
              v-bind:options="options"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Nota fiscal aquisição"
              v-model="nfAquisicao"
              v-uppercase
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-file-input v-model="fileNfCompra"></v-file-input>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="3">
            <v-menu
              v-model="data2"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDate2"
                  clearable
                  label="Data venda"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="dataVenda = null"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataVenda"
                @change="data2 = false"
                :max="nowDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <vuetify-money
              v-model="valorVenda"
              label="Valor venda"
              v-bind:options="options"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Nota fiscal venda"
              v-model="nfVenda"
              v-uppercase
              :counter="200"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-file-input v-model="fileNfVenda"></v-file-input>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addImplemento()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-card>
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items-per-page="-1"
          :items="implementosLocal"
          :loading="loading"
          loading-text="Buscando dados..."
        >
          <template v-slot:item.ativo="{ item }">
            <v-checkbox
              v-model="item.ativo"
              :label="item.ativo === true ? 'Ativo' : 'Inativo'"
            ></v-checkbox>
          </template>

          <template v-slot:item.dataAquisicao="{ item }">
            {{ computedDate(item.dataAquisicao) }}
          </template>
          <template v-slot:item.dataVenda="{ item }">
            {{ computedDate(item.dataVenda) }}
          </template>
          <template v-slot:item.valorAquisicao="{ item }">
            {{ formatCurrency(item.valorAquisicao) }}
          </template>
          <template v-slot:item.valorVenda="{ item }">
            {{ formatCurrency(item.valorVenda) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  @click="removeImplemento(item.index)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-close-thick
                </v-icon>
              </template>
              <span>Remover</span> </v-tooltip
            ><v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="info"
                  @click="editaImplemento(item.index)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <v-row align="center">
        <v-col>
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn @click="enviar" color="success" class="mr-4">Salvar</v-btn>
            </template>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog style="z-index: 9999" v-model="showModal" max-width="750px"
      ><v-card>
        <v-card-title>
          <span class="headline">Editar</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formEdit" v-model="valid" lazy-validation>
              <v-row align="center">
                <v-col cols="6" sm="6">
                  <v-text-field
                    label="Implemento *"
                    v-model="nomeEdit"
                    v-uppercase
                    :counter="200"
                    :rules="[(v) => !!v || 'O Implemento é obrigatório']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field
                    label="Descrição"
                    v-model="descricaoEdit"
                    v-uppercase
                    :counter="200"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" sm="3">
                  <v-menu
                    v-model="data1Edit"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDate(dataAquisicaoEdit)"
                        clearable
                        label="Data aquisição"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="dataAquisicaoEdit = null"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataAquisicaoEdit"
                      @change="data1Edit = false"
                      :max="nowDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                  <vuetify-money
                    v-model="valorAquisicaoEdit"
                    label="Valor aquisicao"
                    v-bind:options="options"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Nota fiscal aquisição"
                    v-model="nfAquisicaoEdit"
                    v-uppercase
                    :counter="200"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-file-input
                    v-model="fileNfCompraEdit"
                    label="Anexo NF Aquisição"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="12" sm="3">
                  <v-menu
                    v-model="data2Edit"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDate(dataVendaEdit)"
                        clearable
                        label="Data venda"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="dataVendaEdit = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataVendaEdit"
                      @change="data2Edit = false"
                      :max="nowDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                  <vuetify-money
                    v-model="valorVendaEdit"
                    label="Valor venda"
                    v-bind:options="options"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Nota fiscal venda"
                    v-model="nfVendaEdit"
                    v-uppercase
                    :counter="200"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-file-input
                    v-model="fileNfVendaEdit"
                    label="Anexo NF Venda"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="showModal = false" color="error" class="mr-4">
                  Voltar
                </v-btn>
                <v-btn @click="atualizar" color="success" class="mr-4">
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { enviarImplementosAsync } from "@/services/implementoService";
import { downloadLista } from "@/services/implementoService";
import { getUserRoles } from "@/services/loginService";
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "criarInventario",
  data: () => ({
    loading: false,
    valid: true,
    overlay: false,
    showModal: false,
    nome: null,
    descricao: null,
    valorAquisicao: null,
    nfAquisicao: null,
    fileNfCompra: null,
    valorVenda: null,
    nfVenda: null,
    fileNfVenda: null,
    dataAquisicao: null,
    dataVenda: null,
    indexEdit: null,
    data1: false,
    data2: false,
    nomeEdit: null,
    descricaoEdit: null,
    valorAquisicaoEdit: null,
    nfAquisicaoEdit: null,
    fileNfCompraEdit: null,
    valorVendaEdit: null,
    nfVendaEdit: null,
    fileNfVendaEdit: null,
    dataAquisicaoEdit: null,
    dataVendaEdit: null,
    data1Edit: false,
    data2Edit: false,
    implementosLocal: [],
    headers: [
      { text: "Id", value: "id", sortable: false },
      { text: "Implemento", value: "nome", sortable: false },
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "Data Aquisição", value: "dataAquisicao", sortable: false },
      { text: "VR Aquisição", value: "valorAquisicao", sortable: false },
      { text: "NF Aquisição", value: "nfAquisicao", sortable: false },
      { text: "Data Venda", value: "dataVenda", sortable: false },
      { text: "VR Venda", value: "valorVenda", sortable: false },
      { text: "NF Venda", value: "nfVenda", sortable: false },
      { text: "Anexo Compra", value: "anexoNfCompra", sortable: false },
      { text: "Anexo Venda", value: "anexoNfVenda", sortable: false },
      { text: "Status", value: "ativo", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    options: {
      locale: "pt-BR",
      prefix: "R$",
      precision: 2,
    },
    nowDate: new Date().toISOString().slice(0, 10),
  }),
  computed: {
    ...mapState("equipamento", ["implementos"]),
    computedDate1() {
      return this.dataAquisicao
        ? moment(this.dataAquisicao).format("DD/MM/YYYY")
        : null;
    },
    computedDate2() {
      return this.dataVenda
        ? moment(this.dataVenda).format("DD/MM/YYYY")
        : null;
    },
  },
  methods: {
    ...mapActions("equipamento", ["atualizarImplementos"]),
    async enviar() 
    {
      this.overlay = true;
        const resposta = await enviarImplementosAsync(this.implementosLocal);
        if (resposta) {
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/implemento");
        }
    },
    baixarlista() {
      downloadLista();
    },
    computedDate(data) {
      return data ? moment(data).format("DD/MM/YYYY") : null;
    },
    formatCurrency(currency) {
      if (currency != null && currency.toString() != "") {
        //return "R$ " + currency.toString().replace(/\./g, ",");
        return (
          "R$ " +
          currency
            .toString()
            .replace(/\./g, ",")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        );
      }
    },
    addImplemento: function (e) {
      if (!this.$refs.form.validate()) {
        e.preventDefault();
      }
      var implemento = new Object();
      implemento.id = null;
      implemento.nome = this.nome;
      implemento.descricao = this.descricao;
      implemento.valorAquisicao = this.valorAquisicao;
      implemento.nfAquisicao = this.nfAquisicao;
      implemento.valorVenda = this.valorVenda;
      implemento.nfVenda = this.nfVenda;
      implemento.dataAquisicao = this.dataAquisicao;
      implemento.dataVenda = this.dataVenda;
      if (this.fileNfCompra != null) {
        implemento.anexoNfCompra = this.fileNfCompra.name;
      }
      if (this.fileNfVenda != null) {
        implemento.anexoNfVenda = this.fileNfVenda.name;
      }
      implemento.fileNfCompra = null;
      implemento.fileNfVenda = null;
      implemento.ativo = true;

      implemento.index =
        this.implementosLocal.length === 0
          ? 0
          : this.implementosLocal[this.implementosLocal.length - 1].index + 1;

      this.implementosLocal.push(JSON.parse(JSON.stringify(implemento)));
      this.implementosLocal[implemento.index].fileNfCompra = this.fileNfCompra;
      this.implementosLocal[implemento.index].fileNfVenda = this.fileNfVenda;
      this.nome = null;
      this.descricao = null;
      this.valorAquisicao = null;
      this.nfAquisicao = null;
      this.valorVenda = null;
      this.nfVenda = null;
      this.dataAquisicao = null;
      this.dataVenda = null;
      this.fileNfCompra = null;
      this.fileNfVenda = null;
      this.$refs.form.resetValidation();
    },

    editaImplemento(index) {
      this.indexEdit = index;
      var implemento = this.implementosLocal.filter(
        (e) => e.index === this.indexEdit
      );
      this.nomeEdit = implemento[0].nome;
      this.descricaoEdit = implemento[0].descricao;
      this.valorAquisicaoEdit = implemento[0].valorAquisicao;
      this.nfAquisicaoEdit = implemento[0].nfAquisicao;
      this.valorVendaEdit = implemento[0].valorVenda;
      this.nfVendaEdit = implemento[0].nfVenda;
      this.dataAquisicaoEdit = implemento[0].dataAquisicao;
      this.dataVendaEdit = implemento[0].dataVenda;
      this.fileNfCompraEdit = implemento[0].fileNfCompra;
      this.fileNfVendaEdit = implemento[0].fileNfVenda;
      this.showModal = true;
    },
    removeImplemento(index) {
      this.implementosLocal = this.implementosLocal.filter(
        (e) => e.index != index
      );
    },
    atualizar: function (e) {
      if (!this.$refs.formEdit.validate()) {
        e.preventDefault();
      }
      this.implementosLocal[this.indexEdit].nome = this.nomeEdit;
      this.implementosLocal[this.indexEdit].descricao = this.descricaoEdit;
      this.implementosLocal[this.indexEdit].valorAquisicao =
        this.valorAquisicaoEdit;
      this.implementosLocal[this.indexEdit].nfAquisicao = this.nfAquisicaoEdit;
      this.implementosLocal[this.indexEdit].valorVenda = this.valorVendaEdit;
      this.implementosLocal[this.indexEdit].nfVenda = this.nfVendaEdit;
      this.implementosLocal[this.indexEdit].dataAquisicao =
        this.dataAquisicaoEdit;
      this.implementosLocal[this.indexEdit].dataVenda = this.dataVendaEdit;
      this.implementosLocal[this.indexEdit].fileNfCompra =
        this.fileNfCompraEdit;
      this.implementosLocal[this.indexEdit].fileNfVenda = this.fileNfVendaEdit;

      if (this.fileNfCompraEdit != null) {
        this.implementosLocal[this.indexEdit].anexoNfCompra =
          this.fileNfCompraEdit.name;
      } else if (this.implementosLocal[this.indexEdit].anexoNfCompra == null) {
        this.implementosLocal[this.indexEdit].anexoNfCompra = null;
      }
      if (this.fileNfVendaEdit != null) {
        this.implementosLocal[this.indexEdit].anexoNfVenda =
          this.fileNfVendaEdit.name;
      } else if (this.implementosLocal[this.indexEdit].anexoNfVenda == null){
        this.implementosLocal[this.indexEdit].anexoNfVenda = null;
      }

      this.showModal = false;
      this.nomeEdit = null;
      this.descricaoEdit = null;
      this.valorAquisicaoEdit = null;
      this.valorVendaEdit = null;
      this.nfAquisicaoEdit = null;
      this.nfVendaEdit = null;
      this.dataAquisicaoEdit = null;
      this.dataVendaEdit = null;
      this.indexEdit = null;
      this.fileNfCompraEdit = null;
      this.fileNfVendaEdit = null;
    },
    async obterLista() {
      //var count = 0;
      this.loading = true;
      await this.atualizarImplementos();
      this.implementosLocal = this.implementos.slice(0);
      /*this.implementosLocal.forEach(function (i) {
        if (typeof e === "object") {
          i["index"] = count++;
        }
      });*/
      for (var i = 0; i < this.implementosLocal.length; i++) {
        this.implementosLocal[i].index = i;
      }
      this.loading = false;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoEquipamento: () =>
      import("@/components/Tabs/TabCadastroEquipamento"),
  },
};
</script>
